
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorBase;

        @Prop( { default: false } ) public Movil: boolean;
        @Prop( { default: false } ) public SinMenu: boolean;
        @Prop( { default: true } ) public MostrarTitulo: boolean;

    }
